module.exports = __webpack_public_path__ + "static/media/breakout_room.11b8825a.svg";